import React from "react";
import "./UniqueLeafLoader.css";

const UniqueLoader = () => {
  return (
    <div className="loader-wrapper">
      <div className="dot dot1"></div>
      <div className="dot dot2"></div>
      <div className="dot dot3"></div>
    </div>
  );
};

export default UniqueLoader;
